<template>
    <div v-if="options_loaded && passed_filter" class="stylesoption">
        <div class="form-group" :class="[!valid_selection ? 'has-error' : '']" :data-designer-component-id="component_id">
            <label :for="'question--' + component_id">{{ title }}</label>
            <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
            </select>
            <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                <option>Loading Options...</option>
            </select>
            <div id="helpBlock" class="mt-1 txt-sm txt-light" v-show="show_cill_horn_text">Your {{ cillLabel }} will come with a {{ cillHornLabel }}</div>
        </div>
        <div class="pt-3" v-if="extra_text != ''">
            {{ extra_text }}
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return window.trans('general.cill');
                }
            },
            frameProfile: {
                required: true
            },
            openingDirection: {
                default(){
                    return '';
                }
            },
            threshold: {
                default(){
                    return '';
                }
            },
            doorRange: {
                default(){
                    return '';
                }
            },
            sidePanel: {
                default(){
                    return 'door';
                }
            },
            frameCombination: {
                default(){
                    return '';
                }
            },
            rampInternal: {
              default(){
                return '';
              }
            },
            rampExternal: {
              default(){
                return '';
              }
            },
            category: {
                default(){
                    return 0;
                }
            },
            show_cill_horn_text: {
              default(){
                return true;
              }
            },
            extra_text: {
              required: false,
              default() {
                return '';
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameProfile);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-cill?profile=' + this.frameProfile + '&opening_direction=' + this.openingDirection + '&threshold=' + this.threshold + '&door_range=' + this.doorRange + '&side_panel=' + this.sidePanel + '&frame_combination=' + this.frameCombination + '&ramp_internal=' + this.rampInternal + '&ramp_external=' + this.rampExternal + '&category=' + this.category;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.openingDirection + '_' + this.threshold + '_' + this.doorRange + '_' + this.sidePanel + '_' + this.frameCombination + '_' + this.rampInternal + '_' + this.rampExternal + '_' + this.category;
            },
            cillLabel() {
                return window.trans('general.cill');
            },
            cillHornLabel() {
                return window.trans('general.cillhornsize');
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
